import React from "react"
import './prologue.css';


function Prologue() {
    return (
        <div className= "prologue">
            <head>
            <title>Prologue</title>
            </head>

        <div>
        <h1>Prologue</h1>
        <div className="story">
        <p>
            A snowstorm was building on the peaks of the Ubreshi Mountains. Wind was
            blowing so strong, it could knock a full grown man off his feet.
            Warriors rushed in and out of the tunnels of Caelum Porta, a city carved
            into the Blue Mountain. General U’ra’s room, carved into the southern
            side of one of the peaks, wasn’t much of a place to sleep because of all
            of the weapons she kept there. Daggers, swords, spears, and shields were
            either hanging on the walls or scattered around the stone shelves, it
            was more of an armory than a bedroom.On the stone table layed a map of
            the mountains drawn on deer hide. A midwife carefully removed a pot of
            boiling water from the giant fireplace. She quickly poured some water
            into a clay cup dipping a clean cloth inside. Then she hurried towards
            U’ra who was on the bed grunting in pain. U’ra’s insides twisted,
            pulled, and squeezed. Her muscles, contorting so vigorously that her
            mind had almost gone numb from the pain. Her sheets were stained with
            dried blood. The healers helping the midwife came in and out of the room
            bringing clean cloths and hot water. Her entire body was on fire. Sweat
            and tears trickled down her face as U’ra let out an ear splitting
            scream.</p>
            <p>“Don’t worry, General, you’re almost there, just a little bit more…”said the midwife as she firmly gripped her hand.<br></br>
            “...I’m trying…aghh!” she grunted as the healers tried to hold her legs
            that were jumping up and about.“Just a bit more”<br></br>
            “..Mmph…mmph… ARGHHH!”<br></br>
            “There, there there…”<br></br> </p>

        <p> A beautiful creature covered in blood and skin. Tiny hands, tiny feet.
            So beautiful and pure thought U’ra. The midwife wiped the remains off
            with a white cloth, then wrapped the little one inside a new and clean
            cloth, while it was still screaming. Raging since the moment she came
            into existence. Her tiny fingers were reaching, trying to grab onto
            U’ra. </p>
            <p>“It’s a girl General and oh, just look at her!”<br></br>
            The midwife slowly handed over the baby wrapped in a piece of cloth. Hot
            streams of salty tears grazed down U’ra’s face as she leaned closer to
            her child that she held closely in her arms.<br></br>
            “How,” U’ra paused looking down at the baby, “Just how beautiful you
            are,”<br></br>
            “I bet she’ll be fierce like her mother,” the healer said gazing at the
            baby.<br></br>
            U’ra looked at her newborn, “Will you really be strong just like your
            mother, oh little one?”<br></br>
            She couldn’t help but hold her little hands and rub her little nose.<br />
            “May Ea bless you so you can be even stronger.” She kissed her tender
            forehead.
        </p>
        <p>
            Muffled voices of people were heard outside the room. The midwife
            hesitantly opened the door. Four War-Maidens standing as tall as
            mountains, made their way inside. Each one’s armour caked in dried
            blood. They were exhausted from fighting, eyes behind their helmets
            swollen, bodies worn. One of them stepped forward.<br />
            “General U’ra, may we have a word?”<br />
            U’ra placed her baby in the cradle the midwife had prepared and covered
            herself with a robe as she got up.<br />
            “Sorry for bothering you at such a time General, it’s just that... the
            situation is quite dire.” One of the War-Maidens, M’ahiv said as she
            walked with U’ra from the side of the bed to the table where the map of
            the mountains layed. <br />
            “What is this about? ” U’ra asked.<br />
            “The empire, General, our scouts told us that they passed the Second
            Cave and are now heading towards Caelum Porta.”<br />
            “How did they get so far in such a short time?” U’ra’s face turned pale.
            “Only a week ago the Arzenal army had trouble climbing the Blue
            Mountain.”<br />
            “The Etherians have merged their armies with Ignis and Kandor, General.
            They agreed to combine forces after the Empire saved their people from
            the Red Plague. We’ve heard that certain clans have been helping the
            Arzenal army in exchange for goods. The Etherians promised clans half of
            their wheat during a dry harvest winter,” <br />
            “The Empire has somehow managed to fool everyone into thinking that it
            is our fault! Everyone’s on their side, including Ignis and Kandor,
            General. Even with the remaining War-Maidens, our numbers simply aren’t
            enough,” another War-Maiden next to M’haviv added.<br />
            “What will we do General? Our men and women are exhausted from fighting,
            the Empire has destroyed everything in their path while on their way
            here. Families haven’t a roof to sleep under, people have nowhere to go.
            And now, almost all the War-Maidens are dead.” M’haviv paused for a
            moment, “and the rest are --”<br />
            “Do not speak of it!” U’ra roared, “These mountains are impenetrable,
            and so is Caelum Porta! A fortress that has not been conquered for a
            thousand years. It belonged to our ancestors, the Smilodon Clan and no
            one else! We will make one last stand with what we have left.”<br />
            “General!” yelled M’ahiv. “If we lose this gate, we lose the war—”<br />
            “I AM AWARE OF THAT!” U’ra yelled as a terrible silence ensued her
            thunder-clapping voice. <br />
            “Mark my words, none shall pass any further. And if they do, may Ea be
            with us until the end…”<br />
            The War-Maidens exited the room, fear lingered in their hopeless, weary
            eyes. U’ra turned around and looked the midwife in the eye.<br />
            “If I die, you know what to do…”<br />
            “Yes, General...What should we name her?”
            </p>
        </div>
    </div>
</div>
    )
}

export default Prologue